<template>
  <div class="livechat-container">
    <div class="livechat-container--left" ref="sidebar">
      <div class="chat-list--header">
        <div
          style="display: flex; justify-content: space-between; align-items: center; width: 100%"
        >
          <p>Resolved Chats</p>
          <el-popover placement="right" trigger="click" width="100%">
            <SearchChatFilters tab="resolved" @resetResolvedChatFilters="reset" />
            <el-button slot="reference" size="mini" type="primary">
              <i class="el-icon-search"></i>
            </el-button>
          </el-popover>
        </div>
        <div class="chat-group-label">
          {{ resolvedChatsArray?.length || 0 }} of {{ resolvedBadgeNumber || 0 }} Resolved Chats
        </div>
      </div>
      <div class="chat-list--wrapper">
        <div class="chat-list--main">
          <ResolvedChatsList
            @fetchMoreResolvedChats="fetchMoreResolvedChats"
            :selected-index.sync="selectedIndex"
            :show-more-is-loading="showMoreIsLoading"
            :has-no-more-chats="hasNoMoreChats"
            @on-init-fetch-interaction="onInitFetchInteraction"
          />
        </div>
      </div>
      <div class="livechat-resizer" ref="resizer"></div>
    </div>
    <div v-if="selectedChat" class="livechat-container--right">
      <ChatsInteractions
        ref="interactionsPanel"
        :chats-list="resolvedChatsArray"
        :selected-chat="selectedChat"
        :selected-index.sync="selectedIndex"
        :is-loading="fetchResolvedChatLoading"
        :closed.sync="closed"
      />
      <el-row v-if="$store.state.showAdvanced">
        <JSONEditor v-model="selectedChat" />
      </el-row>
    </div>
    <div class="livechat-container--right" v-else>
      <EmptySelectedChat />
    </div>
  </div>
</template>

<script>
import SearchChatFilters from "./Filter.vue";
import ResolvedChatsList from "./List.vue";
import ChatsInteractions from "@/components/ChatInteractions/Index";
import JSONEditor from "@/components/JSONEditor";
import FETCH_RESOLVED_CHATS_QUERY from "@/graphql/LIVECHATS_GET_RESOLVED.gql";
import COUNT_RESOLVED_CHATS_QUERY from "@/graphql/LIVECHATS_COUNT_RESOLVED.gql";
import { getAvatar } from "@/helperMethods/livechat/util";
import _ from "lodash";
import { mapGetters } from "vuex";
import { splitAbandonedResolvedChats } from "@/helperMethods/livechat/splitAbandonedResolvedChats";
import EmptySelectedChat from "@/components/LiveChat/EmptySelectedChat";

export default {
  name: "ChatsTab",
  components: {
    SearchChatFilters,
    ResolvedChatsList,
    ChatsInteractions,
    JSONEditor,
    EmptySelectedChat,
  },
  props: { resolvedChatLoading: Boolean },
  data() {
    return {
      selectedIndex: 0,
      closed: false,
      type: { name: "resolved" },
      hasNoMoreChats: false,
      showMoreIsLoading: false,
    };
  },
  computed: {
    ...mapGetters([
      "fetchResolvedChatLoading",
      "resolvedChatTags",
      "resolvedChatsArray",
      "unfilteredResolvedChatsArray",
      "resolvedChatFilters",
      "resolvedBadgeNumber",
      "selectedChatId",
      "selectedChat",
    ]),
  },

  methods: {
    getAvatar,
    reset() {
      this.$store.commit("FLUSH_RESOLVED_CHATS_ARRAY");
      this.hasNoMoreChats = false;
    },
    fetchMoreResolvedChats() {
      this.showMoreIsLoading = true;
      const filters = _.cloneDeep(this.resolvedChatFilters);
      filters.offset = this.unfilteredResolvedChatsArray.length;
      this.$store.commit("UPDATE_RESOLVED_LIVECHAT_FILTERS", filters);
    },
    onInitFetchInteraction() {
      this.$nextTick(() => {
        this.$refs.interactionsPanel.showMoreConversation(this.selectedChat, true);
      });
    },
  },
  apollo: {
    resolvedChats: {
      query: FETCH_RESOLVED_CHATS_QUERY,
      variables() {
        return this.resolvedChatFilters;
      },
      fetchPolicy: "no-cache",
      update(result) {
        const newResolvedSessions = _.get(result, "livechatAPI.resolvedSessions", []);

        if (newResolvedSessions.length < this.resolvedChatFilters.limit) {
          this.hasNoMoreChats = true;
        }

        // @todo: do we need to filter on front end as it is already filtered on backend?
        const { resolvedChats, abandonedChats } = splitAbandonedResolvedChats(newResolvedSessions);
        this.$store.commit("SET_RESOLVED_CHATS_ARRAY", {
          resolvedChatsArray: resolvedChats,
          unfilteredResolvedChatsArray: newResolvedSessions,
        });
        this.$store.commit("SET_FETCH_RESOLVED_CHAT_LOADING", false);
        this.showMoreIsLoading = false;
      },
    },
    countResolvedChats: {
      query: COUNT_RESOLVED_CHATS_QUERY,
      variables() {
        return this.resolvedChatFilters;
      },
      fetchPolicy: "network-only",
      update(result) {
        const count = _.get(result, "livechatAPI.countResolvedSessions", 0);
        this.$store.commit("SET_RESOLVED_CHAT_COUNT", { count });
      },
    },
  },
  mounted() {
    const resizer = this.$refs.resizer;
    const sidebar = this.$refs.sidebar;
    this.$emit("initResizer", resizer, sidebar);
  },
};
</script>

<style scoped lang="scss">
@import "../styles/tab.scss";
</style>
